import { fetchProfile as fetchUserProfile } from "PFCore/services/profile";
import { Profile } from "PFTypes";
import React, { createContext, useContext } from "react";

import BookingModal from "./booking_modal";
import { BookingModalType, useBookingModal } from "./use_booking_modal";

type BookingModalContextType = {
  profileId?: number;
  modal: BookingModalType;
  fetchProfile: (id: number) => Promise<Profile> | JQuery.jqXHR<Profile>;
};

const BookingModalContext = createContext({} as BookingModalContextType);

export type BookingModalConfig = {
  profileId?: number;
  fetchProfile?: (id: number) => Promise<Profile> | JQuery.jqXHR<Profile>;
  onModalSubmit?: () => Promise<unknown>;
};

export const BookingModalContextProvider = ({
  children,
  fetchProfile,
  onModalSubmit,
  profileId
}: React.PropsWithChildren<BookingModalConfig>) => {
  const modal = useBookingModal();

  return (
    <BookingModalContext.Provider
      value={{ modal, fetchProfile: fetchProfile || fetchUserProfile, profileId }}
    >
      <BookingModal onSubmit={modal.state.data?.onSubmit || onModalSubmit} />
      {children}
    </BookingModalContext.Provider>
  );
};

export const useBookingModalContext = () => useContext(BookingModalContext);
